import API from './api';

export const listAllRequest = () =>
  API.get('/myAnnotations')
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const listByLessonRequest = ({ courseId, lessonId }) =>
  API.get(`/course/${courseId}/lesson/${lessonId}/myAnnotations`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const storeRequest = ({ courseId, lessonId, annotationData }) =>
  API.post(`/course/${courseId}/lesson/${lessonId}/annotation`, annotationData)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const updateRequest = ({
  courseId,
  lessonId,
  annotationId,
  annotationData,
}) =>
  API.put(
    `/course/${courseId}/lesson/${lessonId}/annotation/${annotationId}`,
    annotationData,
  )
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const removeRequest = ({ courseId, lessonId, annotationId }) =>
  API.delete(
    `/course/${courseId}/lesson/${lessonId}/annotation/${annotationId}`,
  )
    .then(res => res)
    .catch(err => {
      throw err;
    });
